<template lang="pug">
  .quantity-input
    label.u-sr-only(
      v-if="label"
      :for="idForInput"
    ) {{ label }}
    base-button.button--icon.quantity-input__control.quantity-input__control--decrement(
      :disabled="disableDecrement",
      @click="decrement"
    )
      .u-sr-only Decrease Quantity
      icon(
        name="minus"
        :size="iconSize"
        height="23px"
      )
    input.quantity-input__input(
      type="text",
      :id="idForInput"
      :name="name"
      v-model="currentValue",
      :min="min",
      :max="max"
      :placeholder="placeholder",
      readonly
      :tabindex="-1"
    )
    base-button.button--icon.quantity-input__control.quantity-input__control--increment(
      :disabled="disableIncrement",
      @click="increment"
    )
      .u-sr-only Increase Quantity
      icon(
        name="plus"
        :size="iconSize"
        height="23px"
      )
</template>

<script>
  import TextInput from 'scripts/components/forms/TextInput.vue';
  import Icon from 'scripts/components/basic/Icon.vue';
  import BaseButton from 'scripts/components/buttons/BaseButton.vue';

  export default {
    name: 'QuantityInput',
    components: { TextInput, Icon, BaseButton },
    extends: TextInput,
    props: {
      min: {
        type: Number,
        default: 0,
      },
      max: Number,
      value: Number,
      disableIncrement: {
        type: Boolean,
        default: false,
      },
      disableDecrement: {
        type: Boolean,
        default: false,
      },
      iconSize: {
        type: String,
        default: '6px',
      },
      name: String,
      id: String,
    },
    computed: {
      idForInput() {
        return this.id || `quantity_${this._uid}`;
      },
    },
    methods: {
      increment() {
        if (typeof this.max === 'undefined' || this.currentValue < this.max) this.currentValue += 1;
      },
      decrement() {
        if (this.currentValue > this.min) this.currentValue -= 1;
      },
    },
  };
</script>

<style scoped lang="scss">
  .quantity-input {
    display: flex;
    align-items: center;
    position: relative;
    padding: 0;
    width: $spacing-unit * 25;
    flex-shrink: 0;
    font-size: rem(12);
    border: 1px solid $color-black;
  }

  .quantity-input--product-form {
    margin: 0;
    width: 91px;
    font-size: rem(16);
    background: $color-green-900;
    border: 1px solid $color-green-900;

    @include tablet-up {
      width: 112px;
    }
  }

  .quantity-input__input {
    padding: 0;
    width: 33.333%;
    height: 100%;
    text-align: center;
    background: transparent;
    border: 0;
  }

  .quantity-input__control {
    margin: 0;
    padding: ($spacing-unit * 2) $spacing-unit;
    width: 33.333%;
    border: 0;

    &[disabled] {
      opacity: 0.4;

      &,
      &:hover {
        background-color: transparent;
      }
    }

    .icon {
      width: 5px;
      height: auto;
      fill: $color-green-900;

      .quantity-input--product-form & {
        width: 11px;
        height: auto;
        fill: $color-green-900;
      }
    }
  }

  .quantity-input__control--increment {
  }

  .quantity-input__control--decrement {
  }
</style>
